import actions from '../actions';

const initState = {
  severity: '', // success, error, warning, info
  message: '',
  open: false
};

export default function notificationReducer(state = initState, action) {
  switch (action.type) {
    case actions.notification.INIT:
      return { ...initState };
    case actions.notification.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
